module.exports = __webpack_public_path__ + "img/image3.c49c8202.png";